import { DispatchPreviewTag } from "@api/graphql/generated/generated-types";

export function displayDispatchPreviewTag(
  tag: DispatchPreviewTag
): string | undefined {
  switch (tag) {
    case DispatchPreviewTag.Closest:
      return "Closest";
    case DispatchPreviewTag.LeastDeviation:
      return "Least Deviation";
    case DispatchPreviewTag.LeastTasks:
      return "Least Tasks";
    case DispatchPreviewTag.LeastWorkload:
      return "Least Workload";
    case DispatchPreviewTag.FastestDelivery:
      return "Fastest Delivery";
    case DispatchPreviewTag.NoTask:
      return "No Task";
    case DispatchPreviewTag.TooFar:
      return "Too far";
    case DispatchPreviewTag.NoLocationData:
      return "Location unavailable";
    case DispatchPreviewTag.WeightCapacityLimit:
      return "Weight capacity limit";
    case DispatchPreviewTag.WrongVehicleType:
      return "Wrong vehicle type";
    default:
      return undefined;
  }
}
